import React from 'react';
import { styled } from '@linaria/react';

const frGetter = (value: string | number): string => typeof value === 'number' ? `repeat(${value}, 1fr)` : value;

const formatAreas = (areas: string[]): string => areas.map(area => `"${area}"`).join(" ");

const Container = styled.div<StyledProps>`
  display: grid;
  height: ${props => props.height + ''};
  grid-auto-flow: ${props => props.gridAutoFlow};
  grid-auto-rows: ${props => props.gridAutoRows};
  
  grid-template-columns: ${props => frGetter(props.columns)};
  grid-gap: ${props=> props.gap};
  ${props => props.columnGap ? (`column-gap: ${props.columnGap};`) : ''}
  ${props => props.rowGap ? (`row-gap: ${props.rowGap};`) : ''}
  ${props => props.areas ? (`grid-template-areas: ${formatAreas(props.areas)};`) : ''}
  ${props => props.justifyContent ? (`justify-content: ${props.justifyContent};`) : ''}
  ${props => props.alignContent ? (`align-content: ${props.alignContent};`) : ''}
  ${props => props.rows ? `grid-template-rows: ${frGetter(props.rows)};` : ''}
`

interface StyledProps {
  height: string | undefined;
  gridAutoFlow: string;
  gridAutoRows: string;
  rows?: string | number | undefined;
  columns: string | number;
  gap: string;
  columnGap?: string | undefined;
  rowGap?: string | undefined;
  areas?: string[] | undefined;
  justifyContent?: string | undefined;
  alignContent?: string | undefined;
}

export interface GridProps {
  className: string;
  columns: string | number;
  gap: string;
  columnGap?: string | undefined;
  rowGap?: string | undefined;
  height: string;
  minRowHeight: string;
  flow: string;
  rows?: string | number | undefined;
  areas?: string[] | undefined;
  justifyContent?: string | undefined;
  alignContent?: string | undefined;
  children?: React.ReactNode;
  ref?: any;
}

function Grid({
  className,
  children,
  minRowHeight,
  columnGap,
  flow,
  ref,
  ...props
}: GridProps) {
  const gridAutoRows = `minmax(${minRowHeight}), auto`;
  const gridAutoFlow = flow;
  return <Container
    ref={ref}
    className={className}
    columnGap={columnGap}
    gridAutoRows={gridAutoRows}
    gridAutoFlow={gridAutoFlow}
    {...props}
  >
    {children}
  </Container>;
};

Grid.defaultProps = {
  className: '',
  columns: 12,
  minRowHeight: '20px',
  gap: '8px',
  height: 'auto',
  flow: 'row'
}

export default Grid;
